import React from 'react';

export default function DarknessVignette({
  active,
  intensity = 0,
  pulseStrength = 0,
  madness = 0,
  lowFx = false,
  aggressiveLowFx = false,
}) {
  return (
    <div
      aria-hidden="true"
      className="dd-sanity-vignette"
      style={{
        opacity: active ? 1 : 0,
        '--dd-vignette-opacity': String(aggressiveLowFx ? Math.max(0, intensity * 0.82) : intensity),
        '--dd-pulse-opacity': String(lowFx ? 0 : pulseStrength),
        '--dd-vignette-scale': String(lowFx ? 1 : (1 + madness * 0.025)),
        '--dd-vignette-blur': lowFx ? '0px' : '1px',
        '--dd-pulse-display': lowFx ? 'none' : 'block',
        '--dd-vignette-core-opacity': aggressiveLowFx ? String(Math.max(0, intensity * 0.82)) : '0',
        '--dd-vignette-shell-opacity': aggressiveLowFx ? String(Math.max(0, intensity * 0.94)) : '0',
      }}
    >
      <style>{`
        .dd-sanity-vignette{
          position: fixed;
          inset: 0;
          z-index: 35; /* above board, below HUD */
          pointer-events: none;
          transition: opacity 260ms ease;
        }

        .dd-sanity-vignette::before{
          content:"";
          position:absolute;
          inset:0;
          background:
            radial-gradient(
              ellipse at center,
              rgba(0,0,0,0) 34%,
              rgba(72,24,120, calc(var(--dd-vignette-opacity) * 0.35)) 58%,
              rgba(108,42,180, calc(var(--dd-vignette-opacity) * 0.72)) 76%,
              rgba(32,0,58, calc(var(--dd-vignette-opacity) * 1.1)) 100%
            ),
            radial-gradient(
              ellipse at center,
              rgba(0,0,0,0) 42%,
              rgba(16,0,26, var(--dd-vignette-core-opacity, 0)) 78%,
              rgba(0,0,0, var(--dd-vignette-shell-opacity, 0)) 100%
            );
          filter: var(--dd-vignette-blur, 1px);
          transform: scale(var(--dd-vignette-scale));
        }

        .dd-sanity-vignette::after{
          content:"";
          position:absolute;
          inset:-4%;
          background:
            radial-gradient(circle at 18% 26%, rgba(160,80,255, calc(var(--dd-pulse-opacity) * 0.65)) 0 10%, rgba(160,80,255,0) 34%),
            radial-gradient(circle at 82% 22%, rgba(120,50,220, calc(var(--dd-pulse-opacity) * 0.52)) 0 10%, rgba(120,50,220,0) 36%),
            radial-gradient(circle at 14% 78%, rgba(170,90,255, calc(var(--dd-pulse-opacity) * 0.56)) 0 10%, rgba(170,90,255,0) 34%),
            radial-gradient(circle at 84% 82%, rgba(110,40,210, calc(var(--dd-pulse-opacity) * 0.48)) 0 10%, rgba(110,40,210,0) 38%);
          /* Reduce the blur radius from 22px to 10px to lighten GPU load while
             preserving the vignette glow effect. A smaller blur still softens
             the edges but avoids excessive GPU compositing overhead. */
          filter: blur(10px);
          animation: ddSanityPulse 2.8s ease-in-out infinite;
          mix-blend-mode: screen;
          display: var(--dd-pulse-display, block);
        }

        @keyframes ddSanityPulse{
          0%   { opacity: 0.55; transform: scale(1.00); }
          50%  { opacity: 1.00; transform: scale(1.03); }
          100% { opacity: 0.55; transform: scale(1.00); }
        }
      `}</style>
    </div>
  );
}
